// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"97a458b6","850":"0a0e5401"}[chunkId] + ".chunk.js";
};